module.exports = __webpack_public_path__ + "img/made_with_new.e5413fa6.svg";